import { useCallback, useState } from "react"

const useModal = (initialValue = false) => {
  const [open, setOpen] = useState(initialValue)

  const openModal = useCallback(() => {
    setOpen(true)
  }, [])
  const closeModal = useCallback(() => {
    setOpen(false)
  }, [])
  return [open, openModal, closeModal]
}

export default useModal
